import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setStatus('error');
      setMessage('Doğrulama token\'ı bulunamadı');
      return;
    }

    verifyEmail(token);
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      const response = await axios.get(`/api/auth/verify-email?token=${token}`);
      setStatus('success');
      setMessage(response.data.message || 'E-posta başarıyla doğrulandı!');
      
      // Update user data if logged in
      const userToken = localStorage.getItem('userToken');
      if (userToken) {
        try {
          const userResponse = await axios.get('/api/users/me', {
            headers: { Authorization: `Bearer ${userToken}` }
          });
          const userData = { ...userResponse.data, emailVerified: true };
          localStorage.setItem('userData', JSON.stringify(userData));
          window.dispatchEvent(new Event('userTokenChanged'));
        } catch (err) {
          console.error('Error updating user data:', err);
        }
      }
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.error || 'E-posta doğrulanırken bir hata oluştu');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-dark px-4">
      <div className="bg-gradient-card p-8 rounded-xl shadow-card border-2 border-gold/30 w-full max-w-md">
        {status === 'loading' && (
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-gold mx-auto mb-4"></div>
            <h1 className="text-2xl font-bold text-gold mb-2">E-posta Doğrulanıyor...</h1>
            <p className="text-white/70">Lütfen bekleyiniz</p>
          </div>
        )}

        {status === 'success' && (
          <div className="text-center">
            <div className="text-6xl mb-4">✅</div>
            <h1 className="text-3xl font-bold text-gold mb-4">Başarılı!</h1>
            <p className="text-white mb-6">{message}</p>
            <div className="space-y-3">
              <Link
                to="/"
                className="block w-full bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-gold"
              >
                Ana Sayfaya Dön
              </Link>
            </div>
          </div>
        )}

        {status === 'error' && (
          <div className="text-center">
            <div className="text-6xl mb-4">❌</div>
            <h1 className="text-3xl font-bold text-red-400 mb-4">Hata</h1>
            <p className="text-white mb-6">{message}</p>
            <div className="space-y-3">
              <Link
                to="/"
                className="block w-full bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-gold"
              >
                Ana Sayfaya Dön
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
